import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { initialDashboardState } from './dashboard.state'

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: initialDashboardState,
  reducers: {
    setSelectedCounty: (state, action: PayloadAction<string>) => {
      state.selectedCounty = action.payload
    },
    setAppBarVisible: (state, action: PayloadAction<boolean>) => {
      state.appBarVisible = action.payload
    },
    toggleAppBar: (state) => {
      state.appBarVisible = !state.appBarVisible
    },
    setInitialSetupCompleted: (state, action: PayloadAction<boolean>) => {
      state.initialSetupCompleted = action.payload
    },
  },
})

export const { setSelectedCounty, setAppBarVisible, toggleAppBar, setInitialSetupCompleted } =
  dashboardSlice.actions
export default dashboardSlice.reducer
